import { requestWithRetry, retryConfigs } from '../utils/request';
import request from '../utils/request';

export interface Notice {
  id: number;
  type: number; // 1-滚动公告 2-固定公告
  content: string;
  status: number; // 0-禁用 1-启用
  admin_id: number;
  addtime: number;
  updatetime: number;
}

export interface ApiResponse<T> {
  code: number;
  message: string;
  data?: T;
}

// 获取公告列表 - request实例已有自动重试机制
export const getNotices = async (): Promise<ApiResponse<Notice[]>> => {
  return request.get('/notices');
}; 